import React, { useEffect, useState } from "react";
import AdminLayout from "../../components/layout/AdminLayout";
import AdminSelect from "../../components/AdminSelect";
import AcquisitionDashboard from "../../components/AcquisitionDashboard";
import { adminApi } from "../../api";
import { getToken } from "../../utils/authStorage";

const ymd = (d) => d.toISOString().slice(0, 10);
function defaultRange() {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 90);
  return { from: ymd(from), to: ymd(to), granularity: "day" };
}

export default function AdminAnalytics() {
  const [venues, setVenues] = useState([]);
  const [venueId, setVenueId] = useState(""); // "" = all venues
  const [filters, setFilters] = useState(defaultRange);
  const [drill, setDrill] = useState({});
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [members, setMembers] = useState([]);
  const [membersTotal, setMembersTotal] = useState(0);
  const [membersLoading, setMembersLoading] = useState(true);

  useEffect(() => {
    adminApi.getVenues().then((v) => setVenues(Array.isArray(v) ? v : [])).catch(() => {});
  }, []);

  // Summary. venue_id "" → all venues (backend adds a byVenue split).
  useEffect(() => {
    let alive = true; setLoading(true); setError("");
    adminApi.getAcquisition({ venue_id: venueId, from: filters.from, to: filters.to, granularity: filters.granularity })
      .then((d) => { if (alive) setSummary(d); })
      .catch((e) => { if (alive) setError(e.message); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [venueId, filters]);

  // Detail table.
  useEffect(() => {
    let alive = true; setMembersLoading(true);
    adminApi.getAcquisitionMembers({
      venue_id: venueId, from: filters.from, to: filters.to,
      source: drill.source, medium: drill.medium, campaign: drill.campaign, limit: 500,
    })
      .then((d) => { if (alive) { setMembers(d.rows || []); setMembersTotal(d.total || 0); } })
      .catch(() => { if (alive) { setMembers([]); setMembersTotal(0); } })
      .finally(() => { if (alive) setMembersLoading(false); });
    return () => { alive = false; };
  }, [venueId, filters, drill]);

  async function onExport() {
    const token = getToken();
    const url = adminApi.acquisitionCsvUrl({
      venue_id: venueId, from: filters.from, to: filters.to,
      source: drill.source, medium: drill.medium, campaign: drill.campaign,
    });
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) { setError("Export failed. Please try again."); return; }
    const blob = await res.blob();
    const u = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = u; a.download = "acquisition-attribution.csv"; a.click();
    URL.revokeObjectURL(u);
  }

  const venueFilter = (
    <div className="form-field" style={{ margin: 0, minWidth: 220 }}>
      <label>Venue</label>
      <AdminSelect
        value={venueId}
        onChange={(v) => { setVenueId(v); setDrill({}); }}
        options={[{ value: "", label: "All venues" }, ...venues.map((v) => ({ value: String(v.id), label: v.name }))]}
      />
    </div>
  );

  return (
    <AdminLayout>
      <AcquisitionDashboard
        summary={summary} loading={loading} error={error}
        members={members} membersTotal={membersTotal} membersLoading={membersLoading}
        filters={filters} setFilters={setFilters}
        drill={drill} setDrill={setDrill}
        onExport={onExport}
        extraFilter={venueFilter}
        showVenue={!venueId}
        title="Acquisition Analytics"
        subtitle="Signup attribution across all venues — campaigns, channels & referrers"
      />
    </AdminLayout>
  );
}
